import VideoPlayer from '../media/VideoPlayer'
import type { VideoTracking } from '../media/useVideoAnalytics'
import type { LessonDetail } from '../../lib/content'

type LessonVideo = NonNullable<LessonDetail['video']>

/**
 * Thin adapter that plays a course lesson / trailer through the shared
 * {@link VideoPlayer}. The lesson/course API hands back an HLS source (`src` is
 * a `master.m3u8` behind the video.gazar.dev Worker) plus whether it needs a
 * playback token; this maps that onto VideoPlayer's `hls` source. All the player
 * UI and behaviour lives in VideoPlayer, shared with the article hero.
 */
export default function LessonPlayer({
  video,
  track,
  aspectRatio,
  poster,
}: {
  video: LessonVideo
  track?: VideoTracking
  /** CSS aspect-ratio for the frame (e.g. "1660 / 1080"). Omit for the 16:9 default. */
  aspectRatio?: string
  /** Frame shown before playback starts (usually the course/lesson cover). */
  poster?: string | null
}) {
  return (
    <VideoPlayer
      source={{
        type: 'hls',
        src: video.src,
        requiresToken: video.requiresToken,
        courseSlug: video.courseSlug,
      }}
      poster={poster}
      aspectRatio={aspectRatio}
      track={track}
    />
  )
}
